export const VIEW_DETAILS_PAGE1 = "VIEW_DETAILS_PAGE1";
export const VIEW_DETAILS_PAGE2 = "VIEW_DETAILS_PAGE2";
export const VIEW_DETAILS_PAGE3 = "VIEW_DETAILS_PAGE3";